var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageCountries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.504H15.794C17.964 20.504 19.722 18.746 19.722 16.576C19.722 15.534 19.308 14.534 18.572 13.798L15.164 10.39",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2388 29.446L28.7708 25.744C28.3248 25.074 27.5728 24.672 26.7668 24.672C25.8548 24.672 25.0208 24.156 24.6128 23.34L24.4288 22.97C24.0888 22.292 24.0888 21.494 24.4288 20.816L26.0028 17.67C26.4108 16.854 27.2448 16.338 28.1568 16.338H34.2788",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 44.5H16.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 34.5L9.772 33.228C16.8 40.256 28.2 40.258 35.228 33.228C42.256 26.2 42.256 14.8 35.228 7.772C34.546 7.09 33.812 6.494 33.056 5.944L34.5 4.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 38.5V44.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3388 11.6651C36.2204 16.5467 36.2204 24.4613 31.3388 29.3428C26.4573 34.2244 18.5427 34.2244 13.6612 29.3428C8.77961 24.4612 8.77961 16.5467 13.6612 11.6651C18.5427 6.78358 26.4573 6.78358 31.3388 11.6651",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageCountries);
export default __webpack_public_path__ + "static/media/manageCountries.d87de3734fbe74fc89a705c3d510df07.svg";
export { ForwardRef as ReactComponent };